import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const deleteUpscaleMedia = async (id: string) => {
  const res = await axiosInstance.delete('/api/upscale/delete/' + id);
  return res.data;
};

export const useDeleteUpscaleMedia = () => {
  return useMutation(deleteUpscaleMedia, { onSuccess: (data) => data });
};
